/** Abbreviated English month labels (index 0 = January). */
export const ShortMonthNames = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
] as const;

/** Formats a 1-based `{ month, year }` as e.g. `Jan 2024`. */
export function formatMonthYear(m: { month: number; year: number }): string {
  return `${ShortMonthNames[m.month - 1] || m.month} ${m.year}`;
}
